import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Balance } from '../balance';
import s from './stats.module.scss';
export const Stats = ({ awardsClicks }) => {
    const clampedAwardsClicks = Math.min(awardsClicks, 100);
    return (_jsxs("div", { className: s.stats, children: [_jsx(Balance, { prevLoc: "/" }), _jsxs("div", { className: s.statsProgress, children: [_jsxs("div", { className: s.statsProgressInfo, children: [clampedAwardsClicks, "%"] }), _jsx("div", { className: s.statsProgressBar, children: _jsx("div", { className: s.statsProgressLine, style: { width: `${clampedAwardsClicks}%` } }) })] })] }));
};
